export default "__VITE_ASSET__CHpBLu$r__"